export default {
      id: "icon--wear-boots-usage",
      viewBox: "0 0 30 28",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-boots-usage",
      toString: function () {
        return this.url;
      }
    }